import ContentSuggestionListSkeleton from "./ContentSuggestionList";
import ProfileInfoSkeleton from "./ProfileInfo";

export { ContentSuggestionListSkeleton, ProfileInfoSkeleton };
